var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYellowMelon = function SvgYellowMelon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yellow-melon_svg__a)",
    d: "M217.744 119.929c-15.736-92.56-172.684-70.2-168.668 26.073 3.94 94.444 186.739 80.225 168.668-26.073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yellow-melon_svg__b)",
    d: "M217.119 116.735s1.627.158 2.216-.571c.832-1.031 1.665 3.094 1.665 4.126s-1.6 2.263-2.882 3.71a15.1 15.1 0 0 1-.999-7.265"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow-melon_svg__a",
    x1: 49.001,
    x2: 219.001,
    y1: 134.999,
    y2: 134.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B89BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow-melon_svg__b",
    x1: 217.031,
    x2: 221,
    y1: 120,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3295C1"
  })))));
};
export default SvgYellowMelon;